import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { ListOrganizationInvoiceRepository } from '@domain/organization-invoice/repositories/organization-invoice.repository';
import { OrganizationInvoiceService } from '@core/services/entities/organization-invoice.service';
import { ListOrganizationInvoiceRequestDto } from '@domain/organization-invoice/dto/list-organization-invoice.request.dto';
import { ListOrganizationInvoiceResponseDto } from '@domain/organization-invoice/dto/organization-invoice.response.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationInvoiceRepositoryService implements ListOrganizationInvoiceRepository {
  constructor(private OrganizationInvoiceService: OrganizationInvoiceService) {}

  list(
    request: ListOrganizationInvoiceRequestDto,
  ): Observable<ApiResponse<PageableResponse<ListOrganizationInvoiceResponseDto>>> {
    return this.OrganizationInvoiceService.list(request);
  }
}
